// src/components/BusinessCard.js
import React from 'react';
import { useOutreach } from '../context/OutreachContext';
import './BusinessCard.styles.scss';

const BusinessCard = ({ business }) => {
  const {
    Name,
    Phone,
    EMail,
    WebAddres,
    StreetNo,
    StreetName,
    UnitNo,
    PostalCode,
    Ward
  } = business.attributes;

  // Outreach context functions
  const { addCall, addEmail, addVisit } = useOutreach();

  // Wrapped handlers with console logs
  const handleCall = () => {
    console.log('[BusinessCard] ➕ Call:', business);
    addCall(business);
  };

  const handleEmail = () => {
    console.log('[BusinessCard] ➕ Email:', business);
    addEmail(business);
  };

  const handleVisit = () => {
    console.log('[BusinessCard] ➕ Visit:', business);
    addVisit(business);
  };

  return (
    <div className="business-card">
      <h3 className="business-name">{Name || 'No Name'}</h3>
      <p><strong>Phone:</strong> {Phone || 'N/A'}</p>
      <p><strong>Email:</strong> {EMail || 'N/A'}</p>
      <p>
        <strong>Website:</strong>{' '}
        {WebAddres ? (
          <a href={WebAddres} target="_blank" rel="noopener noreferrer">
            {WebAddres}
          </a>
        ) : (
          'N/A'
        )}
      </p>
      <p>
        <strong>Address:</strong>{' '}
        {StreetNo} {StreetName}
        {UnitNo ? `, Unit ${UnitNo}` : ''}, {PostalCode}
      </p>
      <p><strong>Ward:</strong> {Ward || 'N/A'}</p>

      <div className="card-actions">
        <button className="btn-call"  onClick={handleCall}>  + Call</button>
        <button className="btn-email" onClick={handleEmail}> + Email</button>
        <button className="btn-visit" onClick={handleVisit}> + Visit</button>
      </div>
    </div>
  );
};

export default BusinessCard;
